var TableColumnValueTypes;
(function (TableColumnValueTypes) {
    TableColumnValueTypes[TableColumnValueTypes["String"] = 0] = "String";
    TableColumnValueTypes[TableColumnValueTypes["DateTime"] = 1] = "DateTime";
    TableColumnValueTypes[TableColumnValueTypes["Number"] = 2] = "Number";
})(TableColumnValueTypes || (TableColumnValueTypes = {}));
export default TableColumnValueTypes;
